import { render, staticRenderFns } from "./fragment-gfx3d-board-modification.vue?vue&type=template&id=501584de&scoped=true&"
import script from "./fragment-gfx3d-board-modification.vue?vue&type=script&lang=js&"
export * from "./fragment-gfx3d-board-modification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501584de",
  null
  
)

export default component.exports